import { render, staticRenderFns } from "./ProductCost6.vue?vue&type=template&id=203ac61e&scoped=true"
import script from "./ProductCost6.vue?vue&type=script&lang=js"
export * from "./ProductCost6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203ac61e",
  null
  
)

export default component.exports